import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiTraumiDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoTraumi({ 
              tenantId: currentTenant.Id, 
              assistitoId: assistitoId 
            });
          },
    
          byKey: (key) => {
            return api.getAssistitoTraumaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                traumaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoTrauma({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoTraumaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoTrauma({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                traumaId: key,
                assistitoTraumaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoTrauma({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                traumaId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


